// extracted by mini-css-extract-plugin
export default {"modal-container":"VFBGvr","modalContainer":"VFBGvr","header":"emCncG","modal-body":"HLrSr2","modalBody":"HLrSr2","image":"Q5jv7L","title":"kyl6LK","btn":"WrRre4"};